// tslint:disable

import { Map } from 'immutable';
import { get } from 'lodash';
import * as React from 'react';
import { EntityDetailsComponent } from './entity-details.component';
import './resource-modal.scss';

export class ResourceModal extends React.Component<any> {
    public uid: any = Math.floor(Math.random() * 1000);
    public state: any = {
        isPresent: false,
        entityId: 'create'
    };
    public btnColor = 'primary';

    private resourceLoaderRef: any;

    componentWillMount() {
        (window as any).__MODALS_OPEN = (window as any).__MODALS_OPEN || Map({}).asMutable();
    }

    componentDidMount() {
        if (this.props.btnColor) {
            this.btnColor = this.props.btnColor;
        }

        if (!!this.props.entity) {
            this.setState({entityId: this.props.entityId})
        }

        if (this.props.config && this.props.config.defaultOpen) {
            this.onButtonClick(null);
        }

        if (this.props.onCloseSignal) {
            this.props.onCloseSignal.subscribe(() => {
                this.onCloseModal();
            });
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.entityId !== this.props.entityId) {
            this.setState({entityId: this.props.entityId})
        }
    }


    onPreventDefault(event: any) {
        event.preventDefault();
        event.stopPropagation();
    }

    onButtonClick(event: any): any {
        (window as any).__MODALS_OPEN.set(this.uid, true);
        this.setState({isPresent: true});
        $(this.refs.resourceModal).addClass('open');
    }

    onCloseModal(): any {
        (window as any).__MODALS_OPEN.remove(this.uid, true);
        this.setState({isPresent: false});
        $(this.refs.resourceModal).removeClass('open');
    }

    onCreateSuccessful(event: any): any {

        if (this.props.onCreateSuccessful) {
            this.props.onCreateSuccessful(event);
        }

        if (!this.props.dontClose) {
            this.onCloseModal();
        }

        this.setState({ entityId : get(event, 'id') });

        // this.resourceLoaderRef.reload(this.props.entity, get(event, '@id'))

    }

    onUpdateSuccessful(event: any): any {
        if (this.props.onUpdateSuccessful) {
            this.props.onUpdateSuccessful(event);
        }
        this.onCloseModal();
    }

    render() {
        return (
            <div className={`resource-modal-wrapper ${this.props.baseClass}`}>
                <button type="button" className={`btn btn-${this.btnColor} resource-modal-button ${this.props.extClass}`} onClick={(event: any) => this.onButtonClick(event)}>
                    {this.props.title || 'Open Modal'}
                </button>
                <div className="resource-modal" ref="resourceModal">
                    <div className="multi-modal-close">
                        {(window as any).__MODALS_OPEN.toArray().map((item: number, index: number) => <div key={index} className="holder"/>)}
                        <i className="fa fa-close act" onClick={() => this.onCloseModal()}/>
                    </div>
                    <div className="body">
                        {this.state.isPresent && <EntityDetailsComponent
                            ref={(ref:any) => (this.resourceLoaderRef = ref)}
                            entity={this.props.entity}
                            entityId={this.state.entityId}
                            isModal={true}
                            onCreateSuccessful={(event: any) => this.onCreateSuccessful(event)}
                            onUpdateSuccessful={(event: any) => this.onUpdateSuccessful(event)}
                            config={this.props.config}
                            parentContext={this}
                            onChange$={this.props.onChange$}
                        />}
                    </div>
                </div>

                {this.props.onInitialized && this.props.onInitialized(this) && ''}
            </div>
        );
    }
}

// onClick={(event: any) => this.onButtonClick()}
// onClick={(event: any) => this.onCloseModal()}
/*
{this.state.isPresent && <EntityDetailsComponent
    entity={this.props.entity}
    entityId={this.props.entityId}
    isModal={true}
    onCreateSuccessful={(event: any) => this.onCreateSuccessful(event)}
    onUpdateSuccessful={(event: any) => this.onUpdateSuccessful(event)}
/>}
 */



// WEBPACK FOOTER //
// ./src/components/structurals/resource-modal.tsx